<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-6">
          <z-input
            v-model="subject"
            name="subject"
            label="Subject"
            @keyup="isSave = true"
          />
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <z-textarea
            v-model="noteText"
            name="noteText"
            label="Note"
            :rows="5"
            :maxlength="1000"
            @keyup="isSave = true"
          />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12">
          <file-upload
            ref="fileUploader"
            title=""
            subtitle=""
            instructions="Drag your files (in pdf, doc, png, or jpg format) here to begin or click to browse"
            :endpoint="endpoint"
            :id="orgId"
            :path="path"
            :folder="userId"
            :accept="accept"
            :key="uploadKey"
            :isShowSave="false"
            :isDontSave="true"
            :isShowList="true"
            :existingFiles="existingFiles"
            @filesAdded="filesAttached"
            @show="showFile"
          />
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-md-6">
          <z-input
            v-model="priority"
            type="number"
            name="priority"
            label="Priority"
            min="0"
            @keyup="isSave = true"
            @change="isSave = true"
          />
        </div>
        <div class="col-md-6">
          <input
            v-model="isComplete"
            type="checkbox"
            id="isComplete"
            class="z-checkbox-small custom-checkmark"
            @click="isSave = true"
          />
          <label for="isActive" class="custom-active">Complete?</label>
        </div>
      </div> -->
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1">
          <span>#{{ id }}</span>
        </div>
        <div class="col-md-7">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-4">
          <div class="custom-buttons">
            <button
              v-show="isSave"
              class="btn btn-primary me-2"
              @click="performSave()"
            >
              Save
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import ZTabs from '@/Components/ZElements/Tabs'
import ZInput from '@/Components/ZElements/Input'
import ZSelect from '@/Components/ZElements/Select'
import ZTextarea from '@/Components/ZElements/TextArea'
import FileUpload from '@/Components/ZElements/Upload'
export default {
  name: 'note-dialog',
  components: {
    ZDialog,
    ZTabs,
    ZInput,
    ZSelect,
    ZTextarea,
    FileUpload,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      isSave: false,
      validErrors: [],
      invalidMessage: '',
      accept:
        'image/*,text/*,application/pdf,application/msword,application/vnd.ms-excel,application/vnd.ms-powerpoint,application/gzip,application/zip',
      endpoint: 'api/v2/usernotes/attachments',
      uploadKey: 0,
      path: '',
      badges: [
        {
          name: 'Attachments',
          count: 0,
        },
      ],
      existingFiles: [],
    }
  },
  mounted() {
    this.reset()
  },
  computed: {
    ...mapGetters('users', ['note']),
    ...mapGetters('usercardio', ['member']),
    ...mapGetters('organizations', ['examineOrganization']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = 'Edit Note'
      if (this.show) {
        if (this.show.isAdd) {
          _title = 'Add Note'
        }
      }
      if (this.member) {
        _title += ` for ${this.member.firstName} ${this.member.lastName}`
      }
      return _title
    },
    orgId() {
      let _data = null
      if (
        this.examineOrganization !== undefined &&
        this.examineOrganization !== null
      ) {
        _data = this.examineOrganization.id
      }
      return _data
    },
    userId() {
      let _data = null
      if (this.member) {
        _data = this.member.id
      }
      return _data
    },
    id() {
      let _id = ''
      if (this.note) {
        _id = this.note.id
      }
      return _id
    },
    isAdd() {
      let _is = false
      if (this.show) {
        _is = this.show.isAdd
      }
      return _is
    },
    subject: {
      get() {
        let _data = null
        if (this.note) {
          _data = this.note.subject
        }
        return _data
      },
      set(value) {
        this.setNoteData({
          name: 'subject',
          value: value,
        })
      },
    },
    noteText: {
      get() {
        let _data = null
        if (this.note) {
          _data = this.note.note
          this.setAttachments()
        }
        return _data
      },
      set(value) {
        this.setNoteData({
          name: 'note',
          value: value,
        })
      },
    },
    priority: {
      get() {
        let _data = 0
        if (this.note) {
          _data = this.note.priority
        }
        return _data
      },
      set(value) {
        this.setNoteData({
          name: 'priority',
          value: value,
        })
      },
    },
    isComplete: {
      get() {
        let _data = false
        if (this.note) {
          _data = this.note.is_complete
        }
        return _data
      },
      set(value) {
        this.setNoteData({
          name: 'is_complete',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('users', ['saveNote', 'setNoteData']),
    reset() {
      this.validErrors = []
      this.isSave = false
      this.invalidMessage = ''
      this.badges = [
        {
          name: 'Attachments',
          count: 0,
        },
      ]
      this.existingFiles = []
      if (this.$refs.fileUploader) {
        this.$refs.fileUploader.reset()
      }
    },
    filesAttached(numfiles) {
      this.badges[0].count = numfiles
    },
    setAttachments() {
      try {
        if (this.note) {
          if (this.note.attachments) {
            if (this.note.attachments !== '') {
              let attachList = this.note.attachments.split(';')
              this.existingFiles = []
              attachList.forEach((element) => {
                let segments = element.split('/')
                let filename = segments[segments.length - 1]
                this.existingFiles.push({
                  name: filename,
                  url: element,
                })
              })
              this.badges[0].count = this.existingFiles.length
            }
          }
        }
      } catch (e) {
        console.error('Error Set Attachments', e)
      }
    },
    showFile(file) {
      this.$emit('show', file)
    },
    validate() {
      let valid = true
      this.validErrors = []
      this.invalidMessage = ''
      if (this.note.note === '') {
        valid = false
        this.validErrors.push('missing note')
      }
      return valid
    },
    async performSave() {
      let success = false
      let valid = this.validate()
      if (valid) {
        let attachments = ''
        let files = await this.$refs.fileUploader.save()
        if (files) {
          files.forEach((element) => {
            if (attachments !== '') {
              attachments += ';'
            }
            attachments += element.Url
          })
          this.setNoteData({
            name: 'attachments',
            value: attachments,
          })
        }
        // save the note
        await this.saveNote(this.note)
        success = true
        this.isSave = false
        this.reset()
        this.$emit('saved')
      } else {
        success = false
        this.invalidMessage = this.validErrors.join(', ')
      }
      return success
    },
    close() {
      this.reset()
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-active {
  margin-left: 5px;
}
.custom-checkmark {
  margin-top: 35px;
}
.custom-classes {
  position: relative;
}
.custom-loading-classes {
  position: absolute;
  top: 0;
  left: 200px;
  color: red;
  font-weight: 500;
}
</style>
